// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"718":"174f7fcb","758":"a25bcea0"}[chunkId] + ".chunk.css";
};